import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Router } from '@angular/router';
import { RouteTypes } from '@app/enums/_index';

@Component({
  selector: 'app-route-button',
  imports: [CommonModule],
  templateUrl: './route-button.component.html',
  styleUrls: ['./route-button.component.scss'],
})
export class RouteButtonComponent implements OnInit {
  @Input() id: string; // Unique id
  @Input() routeType = 'internal'; // Default Indicates if the routeType is 'internal' for internal routing, anything else is external including mailTo: emails
  @Input() route: string; // Link route used for card titles and card descriptions
  @Input() secondaryLinkRoute: string; // Secondary route used to handle a second internal route type (ex. Subscription Required)
  @Input() queryParams: any; // Route query parameters to passed to a route

  @Input() buttonRoute: string; // Button Call to action route, but is not necessary the same as the link route
  @Input() actionLabel: string; // Button CTA - Call to Action display label
  @Input() secondaryActionLabel: string;
  @Input() customButtonCss = 'btn-primary'; // Default primary button css
  @Input() showButton = true; // Default to show button
  @Input() mailToDetails: any; // This is used to add mailto content for RouteType mailto
  @Input() actionButtonCss: string;
  @Input() showErrorMessage: boolean;
  @Input() errorMessage: string;
  @Input() showSecondaryButton: boolean;

  @Output() buttonClick = new EventEmitter<object>();
  @Output() secondaryButtonClick = new EventEmitter<object>();

  constructor(public router: Router) {}

  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * On click handle the incoming route if it is an internal route. If it is
   * an internal route, we assume the route is defined and we navigate to this route.
   * Assume query params is already in the {} object
   * If the route type is 'click', then we send an emitter to the parent component and
   * let parent component handle the click event.
   *
   */
  onClick(): void {
    const clickButtonFlag = true;
    const actionLabel = this.actionLabel;
    const clickType = RouteTypes.LINK;
    switch (this.routeType) {
      case RouteTypes.INTERNAL:
        this.buttonClick.emit({ clickButtonFlag, actionLabel });
        if (this.route) {
          if (this.route === 'search') {
            this.router.navigate(['search', this.queryParams ? this.queryParams : {}]);
          } else {
            this.router.navigate([this.route]);
          }
        } else {
          // No nothing. Stay on current route. Handles case where you
          // update the call to action but stay on the same page.
          // Example: Enroll from course detail stays on the same page.
        }
        break;
      case RouteTypes.EXTERNAL:
        this.buttonClick.emit({ clickButtonFlag, actionLabel });
        break;
      case RouteTypes.MODAL:
        this.route = '';
        this.buttonClick.emit({ clickButtonFlag, actionLabel });
        break;
      case RouteTypes.LOGIN:
        this.route = 'login';
        this.buttonClick.emit({ clickButtonFlag, actionLabel });
        break;
      case RouteTypes.DISABLED:
        this.route = 'disabled';
        this.buttonClick.emit({ clickButtonFlag, actionLabel });
        break;
      case RouteTypes.SUBSCRIPTION:
        // Used with Subscription Required or Learn More
        if (this.secondaryLinkRoute) {
          this.router.navigate([this.secondaryLinkRoute]);
        }
        break;
      default:
        // NO-OP - do nothing, including the route types for login
        break;
    }
  }

  /**
   * Secondary Click to handle the incoming route.
   */
  onSecondaryClick() {
    const clickButtonFlag = true;
    const secondaryActionLabel = this.secondaryActionLabel;
    switch (this.routeType) {
      case RouteTypes.EXTERNAL:
        this.secondaryButtonClick.emit({ clickButtonFlag, secondaryActionLabel });
        break;
      default:
        // NO-OP - do nothing, including the route types for login
        break;
    }
  }

  /**
   *  RouteTypes enums based on route types
   */
  public get routeTypes(): typeof RouteTypes {
    return RouteTypes;
  }
}
